import React, { useEffect, useState } from "react";
import { Col, Collapse, Row, Space, notification } from "antd";
import UnionIntersectionSelection from "./UnionIntersectionSelection";
import AddUpdateSectionsButton from "./AddUpdateSectionsButton";
import DeleteSection from "./DeleteSectionButton";
import AddNewFilter from "./Filters/AddNewFilter";
import { CensusShopService } from "../../../../Services";
import { useParams } from "react-router-dom";
import { _Filter_Items } from "../../../Home/FiltersData";
import DeleteFilter from "./Filters/DeleteFilter";
import UpdateFilter from "./Filters/UpdateFilter";
import { CaretRightOutlined } from "@ant-design/icons";

const { Panel } = Collapse;

const panelStyle = {
	marginBottom: 24,
	background: "#f7f7f7",
	borderRadius: "8px"
};

export const ViewSection = ({ section, refetchSections }) => {
	const { tenantName } = useParams();

	const [uniqueKeys, setUniqueKeys] = useState([]);
	const [keysoading, setKeysLoading] = useState(false);
	useEffect(() => {
		const fetchTenantConfig = async () => {
			try {
				setKeysLoading(true);

				const { data: uniqueKeysData } = await CensusShopService.getTenantUniqueCensusKeys({ tenantName });
				const allKeys = [...(uniqueKeysData?.shopDataKeys || []), ...(uniqueKeysData?.tenantKeys || [])];
				setUniqueKeys(allKeys);
				setKeysLoading(false);
			} catch (error) {
				notification.error({ message: "Error fetching Report Columns" });
				console.error("Error fetching tenant config:", error);
				setKeysLoading(false);
			}
		};
		fetchTenantConfig();
	}, [tenantName]);
	return (
		<Collapse>
			<Panel
				header={section.Label}
				key={section.Key}
				style={panelStyle}
				expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
				expandIconPosition="start"
				extra={[
					<Space>
						{section?._Show_FilterType && <UnionIntersectionSelection selectedValue={section.FilterType} />}
						<AddNewFilter
							mode="Add"
							refetchSections={refetchSections}
							loading={keysoading}
							filterKeys={uniqueKeys}
							tenantName={tenantName}
							section={section}
						/>
						<AddUpdateSectionsButton mode={"update"} section={section} refetchSections={refetchSections} />
						<DeleteSection section={section} refetchSections={refetchSections} />
					</Space>
				]}
			>
				<Row justify="center">
					<Col span={24} style={{ display: "flex", justifyContent: "center", marginTop: "10px" }}>
						<Row
							style={{
								width: "100%"
							}}
						>
							{section?._Childrens?.map((filter, index) => {
								const { _Type, key, _id, _Label, _ApiTag, _Childrens, _extra } = filter;
								return (
									<>
										<Col
											span={21}
											key={key || _id || index}
											style={{
												marginBottom: "10px"
											}}
										>
											{_Filter_Items[_Type] &&
												_Filter_Items[_Type]({
													tenant: tenantName,
													_Label,
													_ApiTag,
													_Childrens,
													_SectionApiTag: section._ApiTag,
													value: undefined,
													resursiveValue: undefined,
													_Other_Lable: undefined,
													_Other_ApiTag: undefined,
													defaultActiveKey: key,
													dispatch: () => {},
													_extra
												})}
										</Col>
										<Col span={3}>
											<Space direction="horizontal">
												<UpdateFilter
													refetchSections={refetchSections}
													keysoading={keysoading}
													uniqueKeys={uniqueKeys}
													tenantName={tenantName}
													section={section}
													filter={filter}
												/>
												<DeleteFilter
													tenantName={tenantName}
													filterId={_id}
													refetchSections={refetchSections}
												/>
											</Space>
										</Col>
									</>
								);
							})}
						</Row>
					</Col>

					<Col span={24} style={{ display: "flex", justifyContent: "center", marginTop: "10px" }}>
						<AddNewFilter
							mode="Add"
							refetchSections={refetchSections}
							circle={true}
							loading={keysoading}
							filterKeys={uniqueKeys}
							tenantName={tenantName}
							section={section}
						/>
					</Col>
				</Row>
			</Panel>
		</Collapse>
	);
};

export default ViewSection;
